import { useState, type InputHTMLAttributes } from 'react';

interface PasswordFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string;
  label: string;
  labelClassName?: string;
}

export function PasswordField({ id, label, labelClassName, ...input }: PasswordFieldProps) {
  const [revealed, setRevealed] = useState(false);
  return <>
    <label className={labelClassName} htmlFor={id}>{label}</label>
    <div className="password-field">
      <input {...input} id={id} type={revealed ? 'text' : 'password'} />
      <button aria-controls={id} aria-label={`${revealed ? 'Hide' : 'Show'} password for ${label}`}
        aria-pressed={revealed} className="password-field__toggle" type="button"
        onClick={() => setRevealed(value => !value)}>{revealed ? 'Hide' : 'Show'}</button>
    </div>
  </>;
}
